import { render } from "./SensorData.vue?vue&type=template&id=8908b8c0"
import script from "./SensorData.vue?vue&type=script&lang=js"
export * from "./SensorData.vue?vue&type=script&lang=js"

import "./SensorData.vue?vue&type=style&index=0&id=8908b8c0&lang=css"
script.render = render

export default script